import React, { useState, useEffect } from "react";
import { getProject } from "../../api/project.api";
import { Project } from "../../model/project.model";
import "./coustumers.component.css";
import { Modal, Box } from '@mui/material';
import Swal from 'sweetalert2';
import ChatTable from "../tasks/chat";
import CustomerInfoView from "./customersInfo"
import { Costumer } from "../../model/costumer.model";
export const Customers: React.FC = () => {
    const [customers, setCustomers] = useState<{ fullName: string; email: string; projects: Project[] }[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showSearch, setShowSearch] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState<Costumer | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        fetchProjects();
    }, []);

    const fetchProjects = async () => {
        try {
            const res = await getProject();
            const groupedByEmail = res.data.reduce((acc, project: Project) => {
                const email = project.email || "ללא דואר אלקטרוני";
                if (!acc[email]) {
                    acc[email] = [];
                }
                acc[email].push(project);
                return acc;
            }, {} as { [key: string]: Project[] });

            const customersList = Object.entries(groupedByEmail).map(([email, projects]) => {
                const fullName = `${projects[0].firstName ?? ''} ${projects[0].lastName ?? ''}`.trim();
                return {
                    fullName,
                    email,
                    projects: projects as Project[]
                };
            });

            setCustomers(customersList);
        } catch (error) {
            console.error("Error fetching projects:", error);
        }
    };

    const filteredCustomers = customers.filter((customer) => {
        const combined = [
            customer.fullName,
            customer.email,
            ...customer.projects.map(p => p.businessName),
            ...customer.projects.map(p => p.status?.value)
        ].join(" ").toLowerCase();
        return combined.includes(searchTerm.toLowerCase());
    });

    return (
        <div className="customers-container">
            <div className="header">
                <div className="header-content">
                    <div className="left-section">
                        <button className="search-toggle" onClick={() => setShowSearch(!showSearch)} title="חיפוש">
                            <svg xmlns="http://www.w3.org/2000/svg" height="50" viewBox="0 0 24 24" width="50" fill="#2c3e50">
                                <path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C8.01 14 6 11.99 6 9.5S8.01 5 10.5 5 15 7.01 15 9.5 12.99 14 10.5 14z" />
                            </svg>
                        </button>
                        {showSearch && (
                            <input type="text" placeholder="חיפוש..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="search-line-inline" autoFocus />
                        )}
                    </div>
                    <h1 className="project-title">לקוחות</h1>
                </div>
            </div>
            <div className="table-wrapper">
                <table className="customers-table">
                    <thead>
                        <tr>
                            <th>פרויקטים</th>
                            <th>דוא"ל</th>
                            <th>שם הלקוח</th>

                        </tr>
                    </thead>
                  
                        <tbody>
                            {filteredCustomers.map((customer, index) => (
                                <tr key={index}  className="clickable-row">
                                    <td className="align-center">{customer.projects.map(p => p.businessName).join(", ")}</td>
                                    <td className="align-center">{customer.email}</td>
                                    <td className="align-left">{customer.fullName}</td>
                                </tr>
                            ))}
                        </tbody>

                  
                </table>
            </div>

            {/* {modalOpen && (
                    <Modal  key={selectedCustomer.customer_id} open={modalOpen} onClose={() => setModalOpen(false)} >
                      <Box
                        sx={{
                          backgroundColor: '#fff',
                          display: "flex",
                          flexDirection: 'row',
                          padding: '20px',
                          borderRadius: '10px',
                          // border: '1px solid #ccc',
                          // boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                          width: '80%',
                          height: "60%",
                          top: "50%",
                          left: "50%",
                          position: 'absolute',
                          direction: 'rtl',
                          transform: 'translate(-50%, -50%)'
                        }}
                      >
                        {selectedCustomer && (
                          <>
                            <CustomerInfoView
                              selectedCustomer={selectedCustomer}
                              refresh={fetchData}
                              onClose={() => setModalOpen(false)}
                            />
                            <ChatTable itemId={selectedCustomer.customer_id}></ChatTable>
                          </>
                        )}
                      </Box>
                    </Modal>
                  )} */}
        </div>
        
    );
};
